module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/vi_kyushu-92f33190b8d47e2cdc34259827e5d067.jpg";